import * as $ from "jquery";
import { SharedContentClient } from "./api/DixApiClient";
import { WorkspaceServiceService } from "./services/workspace-service.service";
import { green, blue } from "color-name";

export class Utils
{
    static requestAnimationFrame = window.requestAnimationFrame || (window as any).mozRequestAnimationFrame|| window.webkitRequestAnimationFrame || (window as any).msRequestAnimationFrame|| function(f){return setTimeout(f, 1000/60)} // simulate calling code 60 
    static cancelAnimationFrame = window.cancelAnimationFrame || (window as any).mozCancelAnimationFrame || function(requestID){clearTimeout(requestID)} //fall back

    public static waitFor(condition: () => boolean, callback: () => any, interval: number = 100) {
        if(!condition()) {
            window.setTimeout(Utils.waitFor.bind(null, condition, callback, interval), interval); /* this checks the flag every x milliseconds*/
        } else {
            callback();
        }
    }

    public static decodeHTMLEntities(text: string) {
        var txt = document.createElement("textarea");
        txt.innerHTML = text;
        return txt.value;
    }

    public static getSelectedOrFirstChart()
    {
        let $chart = $('.chart-selected');
        if($chart.length > 0)
            return $chart[0];

        $chart = $('.chart-container');

        if($chart.length > 0)
            return $chart[0];
        throw "No chart found";
    }

    static openPopup(myURL:any, title:any, myWidth:any, myHeight:any) {
        var left = (screen.width - myWidth) / 2;
        var top = (screen.height - myHeight) / 4;
        var myWindow = window.open(myURL, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + myWidth + ', height=' + myHeight + ', top=' + top + ', left=' + left);

     }

     static openPopupWithHandle(myURL:any, title:any, myWidth:any, myHeight:any) {
        var left = (screen.width - myWidth) / 2;
        var top = (screen.height - myHeight) / 4;
        var myWindow = window.open(myURL, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + myWidth + ', height=' + myHeight + ', top=' + top + ', left=' + left);
        return myWindow;
     }

    static objectSetValues(object: Object, values: {[name: string]: any})
    {
        const objWithFlags = <ObjWithValues><any>object;
        return objWithFlags.values = values;
    }

    static objectSetValue<T>(object: Object, name: string, value: T)
    {
        const objWithFlags = <ObjWithValues><any>object;
        if(objWithFlags.values == undefined)
            objWithFlags.values = {};

        objWithFlags.values[name] = value;

        return objWithFlags.values;
    }

    static objectRemoveValue(object: Object, name: string)
    {
        const objWithFlags = <ObjWithValues><any>object;
        if(objWithFlags.values == undefined)
            objWithFlags.values = {};

        delete objWithFlags.values[name];

        return objWithFlags.values;
    }

    static objectGetValues(object: Object)
    {
        const objWithFlags = <ObjWithValues><any>object;
        if(objWithFlags.values == undefined)
            objWithFlags.values = {};

        return objWithFlags.values;
    }

    static objectHasValue(object: Object, name: string)
    {
        return this.objectGetValue(object, name) !== undefined;
    }

    static objectGetValue(object: Object, name: string)
    {
        const objWithFlags = <ObjWithValues><any>object;
        if(objWithFlags.values == undefined)
            objWithFlags.values = {};

        return objWithFlags.values[name];
    }

    private static sqr(x: number) 
    { 
        return x * x 
    }

    private static dist2(v: Position2D, w: Position2D) 
    { 
        return Utils.sqr(v.x - w.x) + Utils.sqr(v.y - w.y) 
    }

    private static distToSegmentSquared(p: Position2D, v: Position2D, w: Position2D) 
    {
        var l2 = Utils.dist2(v, w);
        if (l2 == 0) return Utils.dist2(p, v);
        var t = ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2;
        t = Math.max(0, Math.min(1, t));
        return Utils.dist2(p, { x: v.x + t * (w.x - v.x),
                            y: v.y + t * (w.y - v.y) });
    }
    
    static distToSegment(p: Position2D, v: Position2D, w: Position2D) 
    { 
        return Math.sqrt(Utils.distToSegmentSquared(p, v, w)); 
    }

    static distToLine(point: Position2D, lineStart: Position2D, lineEnd: Position2D)
    {
        return Math.abs((lineEnd.x - lineStart.x)*(lineStart.y - point.y) - (lineStart.x - point.x)*(lineEnd.y - lineStart.y))/
                Math.sqrt(Math.pow(lineEnd.x - lineStart.x, 2) + Math.pow(lineEnd.y - lineStart.y, 2));
    }

    static dashToCamelCase(input: string) 
    { 
        return input.toLowerCase().replace(/-(.)/g, (match, group1) => group1.toUpperCase());
    }  
}
export type Position2D = {x: number, y: number};
export type ObjWithValues = {values?: {[name: string]: any}};
(window as any).utils = Utils;
